import React, { useState, useContext } from "react";
import css from "./Calculator.module.css";
import AuctionFees from "./AuctionFees";
import TitleCheck from "./TitleCheck";
import CalculatorIcon from "../../../../assets/Icon/Calculator";
import Info from "../../../../assets/Icon/Info";
import Popover from "../../../UI/Popover/Popover";
import Select from "react-select";
import { selectStyle } from "./selectStyle";
import { AppContext } from "../../../../providers/appProvider";
import CalcMultiSelect from "../../../UI/Inputs/CalcMultiSelect";
import { useUpdateEffect } from "../../../../hooks/useUpdateEffect";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { formatUsdAndGel } from "../../../../utils/currency";

const CalculatorPage = () => {
  const { t } = useTranslation();

  const { appState, app } = useContext(AppContext);

  const itemResetData = {
    website_id: "",
    transport_price_id: "",
    reciever_country_id: 0,
    reciever_city_id: 0,
    client_price_transport: 0,
    client_price_internal: 0,
    client_company_win: 0,
  };

  const [newCar, setNewCar] = useState(itemResetData);
  const [lotNumber, setLotNumber] = useState("");
  const [isFetchingLot, setIsFetchingLot] = useState(false);

  const userData = appState.user;
  const userLevel = userData ? userData.level : 0;
  const isDealer =
    userData?.role?.name?.toLowerCase?.() === "dealer";

  const websites = appState.websites
    .filter(
      (website) =>
        !(isDealer && website.name?.toUpperCase?.() === "AUTOMOBY.GE")
    )
    .map((website) => ({
      value: website.id,
      label: website.name,
    }));
    

  const filteredPrices = appState.calculator_prices.filter(
    (price) => price.website && price.website.id === newCar.website_id
  );

  const distinctPrices = [];
  const seenCityIds = new Set();

  filteredPrices.forEach((price) => {
    if (!seenCityIds.has(price.location_city.id)) {
      seenCityIds.add(price.location_city.id);
      distinctPrices.push(price);
    }
  });

  if (
    newCar.transport_price != null &&
    !filteredPrices.some((obj) => obj.id === newCar.transport_price.id)
  ) {
    var price_t = newCar.transport_price;
    const newPrice = {
      ...price_t,
      location_city: {
        ...price_t.location_city,
        name: price_t.location_city.name + " (არქივი)",
      },
    };

    distinctPrices.push(newPrice);
  }

  const prices = distinctPrices.map((price) => ({
    value: price.id,
    label: `${price.location_city?.name}`,
  }));

  const getTransportPrice = (transport_price_id, reciever_city_id) => {
    return new Promise((resolve, reject) => {
      const initialResult = appState.calculator_prices.find(
        (entry) => entry.id === transport_price_id
      );

      if (!initialResult) {
        return reject(
          new Error("Not found initial Price entry by transport_price_id")
        );
      }

      const location_city_id = initialResult.location_city.id;
      const website_id = initialResult.website.id;

      const finalResult = appState.calculator_prices.find(
        (entry) =>
          entry.location_city.id === location_city_id &&
          entry.website.id === website_id &&
          entry.reciever_city.id === reciever_city_id
      );

      if (finalResult) {
        resolve(finalResult);
      } else {
        reject(
          new Error(
            "Not found final Price entry by location_city.id, website.id, and reciever_city.id"
          )
        );
      }
    });
  };

  useUpdateEffect(() => {
    if (newCar.reciever_city_id > 0 && newCar.transport_price_id > 0) {
      const priceResponse = getTransportPrice(
        newCar.transport_price_id,
        newCar.reciever_city_id
      );
      priceResponse
        .then((result) => {
          setNewCar((prevState) => ({
            ...prevState,
            client_price_transport: result.company_price,
            client_price_internal: result.internal_price,
            client_company_win: result.website.company_win,
          }));
        })
        .catch((err) => {
          setNewCar((prevState) => ({
            ...prevState,
            client_price_transport: 0,
            client_price_internal: 0,
            client_company_win: 0,
          }));
        });
    } else {
      setNewCar((prevState) => ({
        ...prevState,
        client_price_transport: 0,
        client_price_internal: 0,
        client_company_win: 0,
      }));
    }
  }, [newCar.reciever_city_id, newCar.transport_price_id]);

  function findTransportPriceString(prices, transport_price_id) {
    const price = prices.find((p) => p.id === transport_price_id);

    if (price && price.sender_country && price.sender_city) {
      return `${price.sender_city.name}`;
    }

    return "";
  }

  const senderPort = findTransportPriceString(
    appState.calculator_prices,
    newCar.transport_price_id
  );

  const handleLotNumberChange = async (e) => {
    const lot = e.target.value.replace(/\D/g, "");
    setLotNumber(lot);

    if (lot.trim().length <= 5) return;

    setIsFetchingLot(true);
    try {
      const response = await axios.get(`https://carflow.ge/api2/searchByLot`, {
        params: {
          lot: lot,
          website_id: newCar.website_id,
        },
      });
      const yardName = response.data?.locationDetails?.yardName;
      if (yardName) {
        // Extract state and city name from yard name
        const stateName = yardName.includes(" - ") 
          ? yardName.split(" - ")[0] 
          : "";
        const cityName = yardName.includes(" - ") 
          ? yardName.split(" - ")[1] 
          : yardName;
        
        // Try multiple naming patterns to find a matching city with prices
        const possibleCityNames = [
          cityName.trim(),                                    // "SAN DIEGO"
          `${stateName.trim()} - ${cityName.trim()}`,         // "CA - SAN DIEGO" 
          `${cityName.trim()} (${stateName.trim()})`,         // "SAN DIEGO (CA)"
          `${yardName.trim()}`                                // "CA - SAN DIEGO" (original)
        ];
        
        let matchingCity = null;
        
        // Find the first city that matches a pattern AND has prices for the current website
        for (const namePattern of possibleCityNames) {
          const candidateCity = appState.cities.find(
            (city) => city.name.trim() === namePattern
          );
          
          if (candidateCity) {
            // Check if this city has prices for the current website
            const hasPrice = appState.calculator_prices.some(
              (price) =>
                price.location_city.id === candidateCity.id &&
                price.website.id === newCar.website_id
            );
            
            if (hasPrice) {
              matchingCity = candidateCity;
              break;
            } else if (!matchingCity) {
              // Keep first matching city as fallback
              matchingCity = candidateCity;
            }
          }
        }

        if (matchingCity) {
          const matchingPrice = appState.calculator_prices.find(
            (price) =>
              price.location_city.id === matchingCity.id &&
              price.website.id === newCar.website_id
          );

          if (matchingPrice) {
            setNewCar((prevState) => ({
              ...prevState,
              reciever_country_id: 1,
              reciever_city_id: 1,
              transport_price_id: matchingPrice.id,
            }));
          } else {
            app.setError("ლოტის ნომრით ვერ მოიძებნა ავტომობილი");
          }
        } else {
          app.setError("ლოტის ნომრით ვერ მოიძებნა ავტომობილი");
        }
      } else {
        app.setError("ლოტის ნომრით ვერ მოიძებნა ავტომობილი");
      }
    } catch (error) {
      app.setError("ლოტის ნომრით ვერ მოიძებნა ავტომობილი");
    } finally {
      setIsFetchingLot(false);
    }
  };

  const calculateLevelAmount = (websiteId, userLevel) => {
    const website = appState.websites.find((site) => site.id === websiteId);
    if (!website || userLevel < 1 || userLevel > 5) return 0;
    return website[`level${userLevel}`] || 0;
  };

  const formatPrice = (amount, fractionDigits = null) =>
    formatUsdAndGel(amount, appState.currencies, fractionDigits);

  return (
    <div>
      <div className={css.modalHead}>
        <h3>
          <span className={css.iconHead}>
            <CalculatorIcon />
          </span>{" "}
          {t("TransportationCalculator")}
        </h3>
      </div>

      <div className={css.head3item}>
        <div className={css.cols}>
          <div className={css.colBox}>
            <h1 className={css.colTitle}>{t("TransportationCalculator")}</h1>

            <div className={css.inp2colCar}>
              <div style={{ width: "100%" }}>
                <Select
                  styles={selectStyle}
                  options={websites}
                  value={websites.find(
                    (option) => option.value === newCar.website_id
                  )}
                  onChange={(selectedOption) => {
                    const selectedWebsite = websites.find(
                      (website) => website.value === selectedOption?.value
                    );

                    setNewCar((prevState) => ({
                      ...prevState,
                      website_id: selectedOption ? selectedOption.value : 0,
                      // Clear receiver country and city when changing website
                      reciever_country_id: 0,
                      reciever_city_id: 0,
                      // Then auto-select for COPART and IAAI
                      ...(selectedWebsite?.label === "COPART.COM" || selectedWebsite?.label === "IAAI.COM" 
                        ? { reciever_country_id: 1, reciever_city_id: 1 }
                        : {}),
                    }));
                    setLotNumber("");
                  }}
                  placeholder={t("WebSite")}
                />
              </div>
            </div>

            {(websites.find((option) => option.value === newCar.website_id)
              ?.label === "COPART.COM" ||
              websites.find((option) => option.value === newCar.website_id)
                ?.label === "IAAI.COM") && (
              <div className={css.inp2colCar}>
                <div style={{ width: "100%" }}>
                  <input
                    type="text"
                    value={lotNumber}
                    onChange={handleLotNumberChange}
                    placeholder={t("LotNumber")}
                    className={css.inputDownPort}
                  />
                  {isFetchingLot && <span>...</span>}
                </div>
              </div>
            )}

            <div className={css.inp2colCar}>
              <div style={{ width: "50%" }}>
                <div className={css.bigtran}>
                  <div className={css.horTitle}>{t("Sender")}</div>
                  <Select
                    styles={selectStyle}
                    options={prices}
                    value={
                      prices.find(
                        (option) => option.value === newCar.transport_price_id
                      ) || null
                    }
                    onChange={(selectedOption) => {
                      setNewCar((prevState) => ({
                        ...prevState,
                        transport_price_id: selectedOption
                          ? selectedOption.value
                          : 0,
                      }));
                    }}
                    placeholder={t("City")}
                  />
                </div>
              </div>
              <div style={{ width: "50%" }}>
                <div className={css.bigtran}>
                  <div className={css.inputDownPort}>{senderPort}</div>
                </div>
              </div>
            </div>

            <div className={css.bigtran}>
              <div className={css.horTitle}>{t("ReceivingPort")}</div>
              <div className={css.inp2colCar}>
                <CalcMultiSelect
                  parentOptions={appState.countries.filter(
                    (country) => country.id === 1
                  )}
                  childOptions={appState.cities}
                  parentId={newCar.reciever_country_id}
                  childId={newCar.reciever_city_id}
                  isNetwork={true}
                  styles={selectStyle}
                  onChange={async (reciever_country_id, reciever_city_id) => {
                    setNewCar((prevState) => ({
                      ...prevState,
                      reciever_country_id: reciever_country_id
                        ? reciever_country_id
                        : 0,
                      reciever_city_id: reciever_city_id ? reciever_city_id : 0,
                    }));
                  }}
                  join={"country_id"}
                  placeholder={t("Country")}
                  placeholderSub={t("Port")}
                />
              </div>
            </div>

            <div className={css.transPriceBottom}>
              {/*
                        <div className={css.transPrice}>
                            <div className={css.transText}>შიდა გადაზიდვა</div>
                            <span>{newCar.client_price_internal} $</span>
                        </div>

                        <div className={ css.transPrice }>
                            <div className={css.transText}>კონტეინერის ღირებულება</div>
                            <span>{newCar.client_price_transport}  $</span>
                        </div>
                        */}

              <div className={css.transPrice}>
                <div className={css.transText}>{t("TransportationCost")}</div>
                <span>


                  {app.hasPermission("SHOW_INFO_TRANSPORTATION_CALC") &&
                    <>
                          {newCar.website_id && (
                            <Popover
                              placement="bottom"
                              content={
                                <div className={css.levelPopover}>
                                  {(() => {
                                    const website = appState.websites.find(
                                      (site) => site.id === newCar.website_id
                                    );
                                    if (!website) return null;
                                    return (
                                      <>
                                        <div className={css.levelPopoverTitle}>{website.name}</div>
                                        <div className={css.levelItem}>
                                          <span>Level 1:</span> <span>{formatPrice(website.level1)}</span>
                                        </div>
                                        <div className={css.levelItem}>
                                          <span>Level 2:</span> <span>{formatPrice(website.level2)}</span>
                                        </div>
                                        <div className={css.levelItem}>
                                          <span>Level 3:</span> <span>{formatPrice(website.level3)}</span>
                                        </div>
                                        <div className={css.levelItem}>
                                          <span>Level 4:</span> <span>{formatPrice(website.level4)}</span>
                                        </div>
                                        <div className={css.levelItem}>
                                          <span>Level 5:</span> <span>{formatPrice(website.level5)}</span>
                                        </div>
                                      </>
                                    );
                                  })()}
                                </div>
                              }
                            >
                              <div className={css.transPriceInfo}>
                                <Info style={{ marginRight: "5px" }} />
                              </div>
                            </Popover>
                          )}
                    </>
                  }

                  {(() => {
                    try {
                      const transport =
                        Number(newCar.client_price_transport) || 0;
                      const internal =
                        Number(newCar.client_price_internal) || 0;

                      if (!transport) return formatPrice(0);

                      if (userLevel !== 0) {
                        const levelAmount = calculateLevelAmount(
                          newCar.website_id,
                          userLevel
                        );
                        return formatPrice(transport + internal + levelAmount);
                      } else {
                        const companyWin =
                          Number(newCar.client_company_win) || 0;
                        return formatPrice(transport + internal + companyWin);
                      }
                    } catch (error) {
                      return formatPrice(0);
                    }
                  })()}
                 </span>
              </div>
              {app.hasPermission("PROVAIDER_VIEW") && ( 
                <div className={css.transPrice}>
                  <div className={css.transText}>{t("Provider")}</div>
                  <span>
                    {(() => {
                      try {
                        const currentPrice = appState.calculator_prices.find(
                          (price) => price.id === newCar.transport_price_id
                        );
                        return currentPrice?.provider || "-";
                      } catch (error) {
                        return "-";
                      }
                    })()}
                  </span>
                </div>
              )}

         
            </div>
          </div>
        </div>
        <div className={css.cols}>
          <TitleCheck />
          <AuctionFees />

        </div>
        <div className={css.cols}>
        </div>
      </div>
    </div>
  );
};

export default CalculatorPage;
